/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LeaguesInputs */



/**
* | output |
* | --- |
* | "Leagues" |
*
* @param {Nav_LeaguesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_leagues = /** @type {((inputs?: Nav_LeaguesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LeaguesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ligas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ligas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionati")
	return /** @type {LocalizedString} */ ("Leagues")
});